import { Dispatch, SetStateAction } from 'react';
import { Button } from '@/components/ui/button';
import USIcon from 'flag-icons/flags/4x3/us.svg';
import SpainIcon from 'flag-icons/flags/4x3/es.svg';
import UkrainianIcon from 'flag-icons/flags/4x3/ua.svg';

import { Language } from '@/api/types.ts';

export const TranslateButton = ({
  originalLang,
  isTranslated,
  setIsTranslated,
}: {
  originalLang: Language;
  isTranslated: boolean;
  setIsTranslated: Dispatch<SetStateAction<boolean>>;
}) => {
  const languageToTranslate = isTranslated ? originalLang : 'english';
  const { icon, alt, buttonText } = getTranslateButtonContent(languageToTranslate);

  return (
    <Button
      variant="text"
      className="ml-auto flex-col gap-1 text-[#143980] text-[8px] font-semibold uppercase"
      onClick={() => setIsTranslated(prev => !prev)}
    >
      {icon && <img
        src={icon}
        alt={alt}
        className="w-10 rounded-sm"
      />}
      {buttonText}
    </Button>
  )
}

function getTranslateButtonContent(language: Language) {
  switch (language) {
    case 'english':
      return {
        icon: USIcon,
        alt: 'US flag',
        buttonText: 'TRANSLATE',
      };
    case 'spanish':
      return {
        icon: SpainIcon,
        alt: 'Spain flag',
        buttonText: 'TRADUCIR'
      };
    case 'russian':
      return {
        icon: undefined,
        alt: undefined,
        buttonText: 'ПЕРЕВЕСТИ'
      };
    case 'ukrainian':
      return {
        icon: UkrainianIcon,
        alt: 'Ukrainian flag',
        buttonText: 'ПЕРЕКЛАСТИ',
      };
    default:
      return {
        icon: undefined,
        alt: undefined,
        buttonText: undefined,
      };
  }
}
